/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {DEAppCard} from '../../../_designereyes/helpers/components/DEAppCard'

export const AppsDashboard: FC = () => {
  const [activeFilter, setActiveFilter] = useState<string>('all')

  const apps = [
    {
      title: "Image Tools",
      createdBy: "Lucas",
      tag: "Data Tool",
      description: "Comprehensive suite for fetching, uploading, and reviewing product images. Streamline your product image management workflow.",
      icon: "fa-solid fa-images",
      iconColor: "#6c5ce7",
      links: [
        {
          title: "Product Images Fetcher",
          to: "/apps/product-images",
          icon: "fa-solid fa-image"
        },
        {
          title: "Product Images Uploader", 
          to: "/apps/product-images-uploader",
          icon: "fa-solid fa-upload"
        },
        {
          title: "Product Images Reviewer",
          to: "/apps/image-reviewer",
          icon: "fa-solid fa-magnifying-glass"
        }
      ],
      vendorNameNeeded: ['Designer Eyes']
    },
    {
      title: "Product Info Analysis",
      createdBy: "Sohaib",
      tag: "Data Tool",
      description: "Analyze and gain insights from product data. Identify trends, patterns, and optimization opportunities in your product catalog.",
      icon: "fa fa-chart-line",
      iconColor: "#00b894",
      links: [
        {
          title: "Open Analysis Tool",
          to: "/apps/info-product-analysis",
          icon: "fa fa-chart-line"
        }
      ],
      vendorNameNeeded: ['Designer Eyes'],
      dashboardsNeeded: ['Data Tools/ Product Data Analyzer']
    },
    {
      title: "Data Reformatter",
      createdBy: "Javiera",
      tag: "Data Tool",
      description: "Transform and reformat data files to match different system requirements. Convert between various data formats seamlessly.",
      icon: "fa-solid fa-arrows-rotate",
      iconColor: "#fd79a8",
      links: [
        {
          title: "Open Reformatter",
          to: "/data-reformatter",
          icon: "fa-solid fa-arrows-rotate"
        }
      ],
      dashboardsNeeded: ['Data Tools/ ETL Logs']
    },
    {
      title: "Status Checker",
      createdBy: "Sohaib",
      tag: "System",
      description: "Monitor ETL processes and system status. Keep track of data pipeline health and performance metrics in real-time.",
      icon: "fa-solid fa-server",
      iconColor: "#e17055",
      links: [
        {
          title: "View Dashboard",
          to: "/status-page",
          icon: "fa-solid fa-chart-simple"
        }
      ],
      dashboardsNeeded: ['Data Tools/ ETL Logs']
    },
    {
      title: 'Amazon Inventory Tools',
      createdBy: 'Lucas',
      tag: 'Inventory',
      description:
        'Tools to manage and analyze Amazon inventory, including restocking calculations and sales data uploads.',
      icon: 'fa-solid fa-boxes-packing',
      iconColor: '#1abc9c',
      links: [
        {
          title: 'Amazon Restocking',
          to: '/apps/amazon-restocking',
          icon: 'fa-solid fa-arrow-right',
        },
        {
          title: 'Helium 10 Uploader',
          to: '/apps/helium10-sales-uploader',
          icon: 'fa-solid fa-upload',
        },
        {
          title: 'Helium 10 Raw Data',
          to: '/apps/helium10-raw-uploader',
          icon: 'fa-solid fa-database',
        },
      ],
      vendorNameNeeded: ['Designer Eyes'],
    },
  ]

  const filteredApps = activeFilter === 'all' 
    ? apps 
    : apps.filter(app => app.tag === activeFilter)

  return (
    <div className="card text-body bg-body">
      {/* Page Header */}
      <div className='card-header d-flex align-items-center  pb-2 pt-2'>
        <h3 className='fw-bolder my-2'>Apps Dashboard</h3>
      </div>
      <div className='card-body bg-body text-body mt-4'>
        {/* Filter Buttons */}
        <h5 className='fw-bolder my-2 p-2 mt-0 pt-0'>Filter By:</h5>
        <div className='d-flex flex-wrap gap-2 mb-6'>
          <button
            className={`btn btn-sm ${activeFilter === 'all' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setActiveFilter('all')}
          >
            All Apps
          </button>
          <button
            className={`btn btn-sm ${activeFilter === 'Data Tool' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setActiveFilter('Data Tool')}
          >
            Data Tools
          </button>
          <button
            className={`btn btn-sm ${activeFilter === 'Inventory' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setActiveFilter('Inventory')}
          >
            Inventory
          </button>
          <button
            className={`btn btn-sm ${activeFilter === 'System' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setActiveFilter('System')}
          >
            System
          </button>
        </div>

        {/* Apps Grid */}
        <div className='row g-6 g-xl-9'>
          {filteredApps.map((app, index) => (
            <DEAppCard
              key={index}
              title={app.title}
              createdBy={app.createdBy}
              tag={app.tag}
              description={app.description}
              icon={app.icon}
              iconColor={app.iconColor}
              links={app.links}
              vendorNameNeeded={app.vendorNameNeeded}
              dashboardsNeeded={app.dashboardsNeeded}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
